<script lang="ts" setup>
interface Props {
  color?: string
  size?: string | number
}

const props = withDefaults(defineProps<Props>(), {
  color: 'currentColor',
  size: '20'
})
</script>

<template>
  <Icon name="ri:close-line" :size="props.size" :style="{color: props.color}"/>
</template>
